import { FieldsContainer } from '@qfa/forms';
import React from 'react';

import { FormSectionCard } from '../FormSectionCard';
import { FormSectionProps } from './types';

const FormSection: React.FunctionComponent<FormSectionProps> = (props) => {
  const {
    hashRoute,
    ignoreHash = false,
    name,
    fieldComponents,
    addons,
    sectionId,
    children,
    additionalCardClasses,
    additionalContentClasses,
    childrenBefore,
  } = props;

  return (
    <FormSectionCard
      title={name}
      hashRoute={hashRoute}
      ignoreHash={ignoreHash}
      addons={addons}
      additionalCardClasses={additionalCardClasses}
      additionalContentClasses={additionalContentClasses}
    >
      {childrenBefore}
      <FieldsContainer>
        {fieldComponents.map((component) => {
          // fields that are inactive will not have full set of attributes
          if (!component.props.id) {
            return component.default;
          }
          return (
            <React.Fragment key={`section-${sectionId}_${component.props.id}`}>
              {component.default}
            </React.Fragment>
          );
        })}
      </FieldsContainer>
      {children}
    </FormSectionCard>
  );
};

export default FormSection;
